export default new class scrollTop {
  constructor() {
    this.scrollTopPanel = 'scroll-top_wrapper';
    this.classScrollTop = 'scroll-top_button';
    this.buttonScrollTop = 'js-scroll-top';
    this.classScrollTopShow = 'scroll-top_button-show';
    this.topPosition = 150;

    this.isPage = document.body.getAttribute('data-page-id');

    this.init();
  }

  init() {
    if ((this.isPage === 'catalog')
      || (this.isPage === 'tags')
      || (this.isPage === 'search')) {
      this.load();
      this.scroll();
    }
  }

  scroll() {
    $(document)
      .on('click', `.${this.buttonScrollTop}`, () => {
        $('body, html')
          .animate({ scrollTop: this.topPosition }, 450);
      });
  }

  load() {
    const div = document.createElement('div');
    const body = document.querySelector('body');
    div.classList.add(this.scrollTopPanel);
    body.append(div);

    $.request('onAjax', {
      update: {
        'common/scroll-top/scroll-top': `.${this.scrollTopPanel}`,
      },
      complete: () => {
        this.activateTop();
      },
    });
  }

  activateTop() {
    $(document)
      .scroll(() => {
        const height = $(window)
          .scrollTop();
        const documentHeight = $(document)
          .height();
        const screenHeight = $(window)
          .height();
        const stickyHeight = $(`.${this.classScrollTop}`)
          .height();

        if (((documentHeight - stickyHeight - 10) >= (height + screenHeight)) && height >= 400) {
          if (!$(`.${this.classScrollTop}`)
            .hasClass(this.classScrollTopShow)) {
            $(`.${this.classScrollTop}`)
              .addClass(this.classScrollTopShow);
          }
        } else {
          $(`.${this.classScrollTop}`)
            .removeClass(this.classScrollTopShow);
        }
      });
  }
}();
